<div class="report-custom">
	<div class="report-custom-toggle text-16">
		<div class="headers">
			<div>
				<dz-toggle-switch
					[toggleOn]="showCustomization"
					[toggleLabel]="'Include Report Customization' | dcr : mode + reportType + '_REPORT_CUSTOMIZATION_HEADER'"
					[dcrKeys]="[mode + reportType + '_REPORT_CUSTOMIZATION_HEADER']"
					(click)="toggleShowCustomization()"
					custom-tracking
					[track-event]="'pdf-customization:include-report-custom-toggle' + mode + ':' + (!showCustomization ? 'on' : 'off')"
				>
				</dz-toggle-switch>
				<icon *ngIf="showInfobubble" type="info-circle" class="info-circle text-16 color-primary" [tooltip]="infoBubble"></icon>
				<ng-template #infoBubble>
					<section dcrHTMLKey="INCLUDE_PDF_CUSTOMIZATION_INFOBUBBLE">INCLUDE_PDF_CUSTOMIZATION_INFOBUBBLE</section>
				</ng-template>
			</div>
			<span *ngIf="showCustomization && showAddCustomPage" class="section-header new-page text-16-bold text-align-right" (click)="openCustomPageDialog()">
				<icon type="file-medical" class="custom-page-icon report-custom-toggle"> </icon>
				<span dcrHTMLKey="REPORT_CUSTOMIZATION_NEW_PAGE_TEXT">Add New Pages</span>
			</span>
		</div>
	</div>

	<div *ngIf="showCustomization" class="customization">
		<div class="customization-loading" *ngIf="isCustomizationLoading">
			<span class="padding-right-5"><dz-progress-spinner [size]="20" [borderWidth]="2"></dz-progress-spinner></span>
			<span [dcrHTMLKey]="mode + 'PDF_CUSTOMIZATION_LOADING_MESSAGE'" class="padding-left-5 text-16">PDF Customization Loading...</span>
		</div>
		<div *ngIf="!isCustomizationLoading && !isCustomizationAvailable">
			<span [dcrHTMLKey]="mode + NO_PDF_CUSTOMIZATION_AVAILABLE_MESSAGE" class="text-16">PDF Customization is currently not available</span>
		</div>
		<div *ngIf="isCustomizationAvailable">
			<section class="row custom-table-headers text-16-bold">
				<span class="col-1">
					<label class="ac-checkbox display-inline-flex">
						<input
							type="checkbox"
							[checked]="isToggleAll"
							(change)="toggleAll($event)"
							class="form-control"
							custom-tracking
							[track-event]="'pdf-customization:include-report-custom-all-sections-toggle' + mode + ':' + (!isToggleAll ? 'on' : 'off')"
							name="toggleAll"
							[id]="'toggleAll-' + mode"
						/>
						<!-- Span is expected for the text-->
						<span></span>
					</label>
				</span>
				<span [class.col-11]="showOptionalCol" [class.col-7]="!showOptionalCol" dcrHTMLKey="CUSTOMIZATION_ALL_SECTIONS">
					<label [attr.for]="'toggleAll-' + mode">All Sections</label>
				</span>
				<span [class.col-12]="showOptionalCol" [class.col-16]="!showOptionalCol" [dcrHTMLKey]="mode + 'CUSTOMIZATION_INCLUDES'">Includes...</span>
			</section>

			<ng-container *ngFor="let section of currentConfig.sections; let sectionIndex = index">
				<section *ngIf="section.visible" class="row custom-table-content" [ngClass]="{ 'highlight-hover': showOrdering }">
					<span class="col-1">
						<label class="ac-checkbox display-inline-flex">
							<input
								*ngIf="section.optional"
								type="checkbox"
								[checked]="section.checked"
								(change)="onSectionCheck(sectionIndex, $event)"
								class="form-control section"
								custom-tracking
								[track-event]="'pdf-customization:include-report-custom-' + section.nameKey + '-toggle:' + (!section.visible ? 'on' : 'off')"
								[name]="section.nameKey"
								[id]="section.nameKey"
							/>
							<!-- Span is expected for the text-->
							<span></span>
						</label>
					</span>

					<span class="col-7 text-15" [dcrHTMLKey]="section.nameKey">
						<label [attr.for]="section.nameKey">{{ section.nameKey }}</label>
					</span>

					<span *ngIf="showOptionalCol" class="col-4 text-14">
						<p *ngIf="!section.optional" dcrHTMLKey="SECTION_NOT_OPTIONAL">*Not optional</p>
						<p *ngIf="section.optional && section.optionalDescriptionKey" [dcrHTMLKey]="section.optionalDescriptionKey">
							<label [attr.for]="section.optionalDescriptionKey">{{ section.optionalDescriptionKey }}</label>
						</p>
					</span>

					<span [class.col-9]="showOptionalCol" [class.col-13]="!showOptionalCol" class="text-14" *ngIf="!section.subsections">
						<span [dcrHTMLKey]="section.descriptionKey">
							<!-- Using span to fix content issue within IE -->
							<span>{{ section.descriptionKey }}</span>
						</span>
					</span>

					<span class="col-9" *ngIf="section.subsections && !dataDrivenSections.includes(section.nameKey)">
						<section *ngFor="let subsection of section.subsections; let subsectionIndex = index">
							<ng-container *ngIf="subsection.visible">
								<label class="ac-checkbox display-inline-flex">
									<input
										*ngIf="!subsection.isNotOptional"
										type="checkbox"
										[checked]="subsection.checked"
										(change)="onSubsectionCheck(sectionIndex, subsectionIndex, $event)"
										class="form-control subsection"
										custom-tracking
										[track-event]="'pdf-customization:include-report-custom-' + subsection.nameKey + '-toggle:' + (!subsection.visible ? 'on' : 'off')"
										[name]="subsection.nameKey"
										[id]="subsection.nameKey"
									/>
									<span class="text-14" [dcrHTMLKey]="subsection.descriptionKey">
										<label [attr.for]="subsection.nameKey">{{ subsection.descriptionKey }}</label>
									</span>
								</label>
								<div *ngIf="subsection.logic">Show some logic here</div>
							</ng-container>
						</section>
					</span>

					<span [hidden]="!showOrdering" class="col-2" *ngIf="section.isOrderable">
						<div class="arrows-row">
							<div class="up-column">
								<span *ngIf="previousSectionIsOrderable(section)" class="chevron-up" (click)="moveSectionUp(section)">
									<icon type="chevron-up"></icon>
								</span>
								<span *ngIf="!previousSectionIsOrderable(section)" class="empty-block"></span>
							</div>
							<div class="down-column">
								<span *ngIf="nextSectionIsOrderable(section)" class="chevron-down" (click)="moveSectionDown(section)">
									<icon type="chevron-down"></icon>
								</span>
							</div>
						</div>
					</span>

					<span class="col-1" *ngIf="section.isUserCreated">
						<div class="delete-row">
							<div class="delete-column">
								<span class="delete" (click)="deleteCustomPage(section)">
									<icon type="times"></icon>
								</span>
							</div>
						</div>
					</span>
				</section>

				<div *ngIf="dataDrivenSections.includes(section.nameKey) && section.visible">
					<section *ngFor="let subsection of section.subsections; let subsectionIndex = index">
						<section *ngIf="subsection.visible" class="row custom-subsection-row" [ngClass]="{ 'highlight-hover': showOrdering }">
							<span class="col-1"></span>
							<!--empty call for spacing purposes-->
							<span *ngIf="!subsection.isNotOptional" [class.col-1]="!subsection.isNotOptional">
								<label class="ac-checkbox display-inline-flex">
									<input
										*ngIf="!subsection.isNotOptional"
										type="checkbox"
										[checked]="subsection.checked"
										(change)="onSubsectionCheck(sectionIndex, subsectionIndex, $event)"
										class="form-control subsection"
										custom-tracking
										[track-event]="mode + 'pdf-customization:include-report-custom-' + subsection.nameKey + '-toggle:' + (!subsection.visible ? 'on' : 'off')"
										[name]="subsection.nameKey"
										[id]="subsection.nameKey"
									/>
									<!-- Span is expected for the text-->
									<span></span>
								</label>
							</span>

							<span [class.col-6]="!subsection.isNotOptional" [class.col-7]="subsection.isNotOptional" class="col-6 text-15" [dcrHTMLKey]="subsection.descriptionKey">
								<label [attr.for]="subsection.descriptionKey">{{ section.descriptionKey }}</label>
							</span>

							<section class="col-16">
								<div *ngIf="subsection.dataMapping === 'PROPOSAL_PURPOSE'">
									<proposal-purpose [showPurposeValidation]="showPurposeValidation"></proposal-purpose>
								</div>

								<div *ngIf="subsection.dataMapping === 'PROPOSAL_HOW'">
									<proposal-metrics [pdfCustomisationConfig]="currentConfig"></proposal-metrics>
								</div>
							</section>
						</section>
					</section>
				</div>
			</ng-container>

			<div class="customization-info" *ngIf="reportType === ViewCategory.PROPOSAL_PDF && mode === 'SNAPSHOT'" dcrHTMLKey="PROPOSAL_CUSTOMIZATION_INFO">
				Please use the toggle "Customize additional sections of the report" to add or remove other sections in your proposal report
			</div>

			<div class="customization-info" *ngIf="showCustomizationFootNote" dcrHTMLKey="PROPOSAL_CUSTOMIZATION_FOOTNOTE">
				Note: Advisors can choose to include or exclude “Performance Commentary” if “Performance (%)” is selected. Similarly, there is an option to include or exclude
				“Changes to Holdings” if “Trade Rationale” is selected.
			</div>
		</div>
	</div>
</div>
